import { ACTIONS } from "./capitalTypes";

export const setCapital = () => {
  return {
    type: ACTIONS.SET_CAPITAL,
  };
};
